import _ from 'lodash';

import AgentActivity from 'models/agent_activity';
import changeCurrentLocation from 'actions/lib/change_current_location';
import EditableUser from 'models/editable_user';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';
import UserEditor from 'models/location/user_editor';

export default class OpenUser {
  constructor(context) {
    this.context = context;
  }

  run(userId) {
    if (!this.context.stores.appFeatures.get().isEnabled('userManagement')) {
      this.context.router.navigateHome();
      return;
    }

    this.updateCurrentLocation(userId);
    this.setUserEditor(userId);
    this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.USERS_ADMIN });
  }

  updateCurrentLocation(userId) {
    changeCurrentLocation(this.context, UserEditor.create({ userId }));
  }

  setUserEditor(userId) {
    let currentEditableUser = this.context.stores.userEditor.get();

    if (!this.storesAreLoading && (!currentEditableUser || currentEditableUser.id !== userId)) {
      let userToEdit = this.context.stores.users.findBy({ id: userId });
      let profileToEdit = this.context.stores.agentProfiles.findBy({ id: userId });
      let routingGroups = this.context.stores.routingGroups.findAll();
      let userRoutingGroupsIds = routingGroups.filter(rg => _.includes(rg.agentIds, userId)).map(rg => rg.id);

      let newEditableUser = EditableUser.create(userToEdit, profileToEdit, userRoutingGroupsIds);
      this.context.stores.userEditor.set(newEditableUser);
      this.context.stores.userEditor.clearErrors();
      this.context.stores.userEditor.resetPending();
    }
  }

  get storesAreLoading() {
    return (
      this.context.stores.users.isLoading() ||
      this.context.stores.agentProfiles.isLoading() ||
      this.context.stores.routingGroups.isLoading()
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/users/open_user.js